module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "sub-header"
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Сотрудники")]), _vm._v(" "), _c('div', {
    staticClass: "header__save"
  }, [(_vm.$store.state.user.role == 'HM') ? _c('span', [_c('router-link', {
    staticClass: "button button--inverse",
    attrs: {
      "title": "",
      "to": {
        path: "/users/add/"
      }
    }
  }, [_vm._v("Добавить пользователя")])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "reports-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "reports-list-body"
  }, _vm._l((_vm.users), function(user) {
    return _c('div', {
      staticClass: "report-item-line",
      on: {
        "click": function($event) {
          return _vm.$router.push(((user.id) + "/"))
        }
      }
    }, [_c('div', {
      staticClass: "report-item report-item__pharmacy"
    }, [_vm._v(_vm._s(user.pharmacy != null ? user.pharmacy.title : ''))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__email"
    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__name"
    }, [_vm._v(_vm._s(user.firstName)), _c('br'), _vm._v(_vm._s(user.lastName))])])
  }), 0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reports-list-head"
  }, [_c('div', {
    staticClass: "report-item report-item--head report-item__pharmacy"
  }, [_vm._v("Аптека")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__email"
  }, [_vm._v("Почта")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__name"
  }, [_vm._v("Имя")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d93f36f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/Users.vue
// module id = 236
// module chunks = 1